import React from 'react';

export const SocialAuthProviders = {
    APPLE: 'apple',
    FACEBOOK: 'facebook',
};

export const MagicLinkLoginSteps = {
    SIGN_IN: 1,
    LOGIN_OPTIONS: 2,
};

export const magicLinkCooldownKey = 'magic_link_cooldown';
export const magicLinkCoolDownTime = 60;
export const magicLinkSuccessTitle = 'Check your email';
export const magicLinkErrorMessage = 'Error submitting magic link';
export const magicLinkTimeout = 15;

export const getMagicLinkSuccessMessage = (email) => {
    return (
        <>
            <p>{`If an email exists for this account, we will send a secure sign-in link to the email address ${email}. Please click the link within ${magicLinkTimeout} minutes to log in.`}</p>
            <p>{'If you don\'t see the email, be sure to check your spam or junk folder.'}</p>
        </>
    );
};
